var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6447_28106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.31031 5.69003C8.11031 5.56003 7.84031 5.56003 7.63031 5.69003C7.43031 5.82003 7.32031 6.03003 7.32031 6.26003V13.74C7.32031 14.02 7.47031 14.27 7.66031 14.32C7.79031 14.39 7.88031 14.39 7.97031 14.39C8.04031 14.39 8.25031 14.39 8.37031 14.19L14.0003 10.49C14.1903 10.36 14.3103 10.16 14.3103 9.96003C14.3103 9.76003 14.1903 9.56003 14.0003 9.43003L8.31031 5.69003ZM12.4803 10L8.61031 12.55V7.44003L12.4803 9.99003V10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM18.7 10C18.7 14.8 14.8 18.7 10 18.7C5.2 18.7 1.3 14.8 1.3 10C1.3 5.2 5.2 1.3 10 1.3C14.8 1.3 18.7 5.2 18.7 10Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6447_28106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVideoIcon);
export default __webpack_public_path__ + "static/media/addVideoIcon.b7c8f1643f68cd6579fab090f2ff50a2.svg";
export { ForwardRef as ReactComponent };